import { Component, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-lb-full-width-dropdown',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './lb-full-width-dropdown.component.html',
  styleUrls: ['./lb-full-width-dropdown.component.scss']
})
export class LbFullWidthDropdownComponent {
  @Input() title: string = 'Default Title';
  @Input() isExpanded: boolean = false; // Input to track toggle state
  @Output() isExpandedChange = new EventEmitter<boolean>();
  constructor(public elementRef: ElementRef) {}
  toggleState(): void {
    this.isExpanded = !this.isExpanded; // Toggle the boolean value
    this.isExpandedChange.emit(this.isExpanded);
  }
}
